import { Fieldset } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { Fragment, forwardRef } from 'react';
import { formatDuration } from 'services/event_types';
import { EventTypeItem } from './event_type_item';
import { EventTypeListSectionHeaderWrapper } from './styles';
import { useGetAvailabilitySchedulesQuery } from '../../../api';
const eyebrowCss = "ejkks45";
const Eyebrow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(eyebrowCss, props.className)} />;
});
const openedETToEventTypeItem = et => ({
  name: et.name,
  color: et.color,
  locationTypes: [],
  editLockedHint: '',
  kindDescription: et.kind_description,
  durationDescription: formatDuration(et.duration, et.duration_options, true),
  canEdit: false
});
export const EventTypeList = ({
  selectedScheduleId,
  linkedEventTypes,
  nonLinkedEventTypes,
  linkedEventTypeIds,
  onChange,
  currentEventType
}) => {
  const {
    data
  } = useGetAvailabilitySchedulesQuery();
  const allSchedules = data || [];
  const selectedSchedule = allSchedules.find(({
    id: scheduleId
  }) => scheduleId === selectedScheduleId);
  const selectedScheduleName = selectedSchedule.name;
  return <Fieldset>
      <div data-component="active-event-type-list">
        {(linkedEventTypes.length > 0 || currentEventType) && <EventTypeListSectionHeaderWrapper>
              <Eyebrow>
                {I18n.t('publisher.availability_page.default_schedule.header.active_event_types_dropdown.list.active', {
            schedule: selectedScheduleName
          })}
              </Eyebrow>
            </EventTypeListSectionHeaderWrapper>}
        {currentEventType && <EventTypeItem key={`${currentEventType.owner_type}-${currentEventType.owner_uuid}`} eventType={openedETToEventTypeItem(currentEventType)} checked />}
        {linkedEventTypes.map(profile => profile.eventTypes.map(eventType => <EventTypeItem key={eventType.id} eventType={eventType} checked={linkedEventTypeIds.includes(eventType.id)} onChange={onChange} currentEventType={currentEventType} />))}
      </div>
      {nonLinkedEventTypes.length > 0 && <div data-component="inactive-event-type-list">
          <EventTypeListSectionHeaderWrapper>
            <Eyebrow>
              {I18n.t('publisher.availability_page.default_schedule.header.active_event_types_dropdown.list.inactive', {
            schedule: selectedScheduleName
          })}
            </Eyebrow>
          </EventTypeListSectionHeaderWrapper>
          {nonLinkedEventTypes.map(profile => <Fragment key={`${profile.type}_${profile.id || 'shared_event_types'}`}>
              {profile.eventTypes.map(eventType => <EventTypeItem key={eventType.id} eventType={eventType} checked={linkedEventTypeIds.includes(eventType.id)} onChange={onChange} currentEventType={currentEventType} />)}
            </Fragment>)}
        </div>}
    </Fieldset>;
};

require("./event_type_list.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_list.js");